import { render, staticRenderFns } from "./LandingPageVideoEditor.vue?vue&type=template&id=53470c45"
import script from "./LandingPageVideoEditor.vue?vue&type=script&lang=js"
export * from "./LandingPageVideoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports